// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._00cfbc{--flex-gutter: var(--gutter);align-items:flex-start;display:flex;gap:var(--flex-gutter)}._00cfbc>:not([aria-roledescription=popup]){margin-top:0}._00cfbc:not(._8e2d4a)>svg{margin-top:.15em}._00cfbc>svg+:not(svg){margin-left:calc(-1*var(--gutter) + .5em)}@media print{._00cfbc h1~svg,._00cfbc h2~svg,._00cfbc h3~svg,._00cfbc h4~svg,._00cfbc h5~svg,._00cfbc h6~svg{display:none}}.d550f6{display:inline-flex}._23eddc{}._4dfb1c{font-size:.9375em}.c9bf22{--flex-gutter: 0.25rem}._504540{--flex-gutter: 0.5rem}._0dbc2c{--flex-gutter: var(--spacer)}._35107b{--flex-gutter: var(--medium-spacer)}._50afd5{--flex-gutter: var(--large-spacer)}._34655c{align-self:center}.e9d982{justify-content:space-between}._845b46{justify-content:space-around}._378f6c{justify-content:space-evenly}._081ace{justify-content:center}._2ea5b5{justify-content:flex-end}._8e2d4a{align-items:center}._3893e2{align-items:flex-end}.aa100a>*{flex:1}.fd35ba{flex-wrap:wrap;margin-bottom:calc(-1*var(--flex-gutter))}.fd35ba>*{margin-bottom:var(--flex-gutter)}@media(orientation: portrait){.fd35ba>*{min-width:55%}}", ""]);
// Exports
exports.locals = {
	"flex": "_00cfbc",
	"middle": "_8e2d4a",
	"inline": "d550f6",
	"spacing": "_23eddc " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["spacing"] + "",
	"small": "_4dfb1c",
	"tiny-gutter": "c9bf22",
	"tinyGutter": "c9bf22",
	"small-gutter": "_504540",
	"smallGutter": "_504540",
	"smedium-gutter": "_0dbc2c",
	"smediumGutter": "_0dbc2c",
	"medium-gutter": "_35107b",
	"mediumGutter": "_35107b",
	"large-gutter": "_50afd5",
	"largeGutter": "_50afd5",
	"align-self-center": "_34655c",
	"alignSelfCenter": "_34655c",
	"justified": "e9d982",
	"space-around": "_845b46",
	"spaceAround": "_845b46",
	"space-evenly": "_378f6c",
	"spaceEvenly": "_378f6c",
	"center": "_081ace",
	"right": "_2ea5b5",
	"bottom": "_3893e2",
	"even": "aa100a",
	"stack": "fd35ba"
};
module.exports = exports;
